export const DROPDOWN_POSITION = {
  top: 'position_top',
  bottom: 'position_bottom',
};
export const DROPDOWN_ALIGN = {
  left: 'align_left',
  right: 'align_right',
};

export const LANGUAGES_DICTIONARY = {
  'ru-us': {
    title: 'Русский',
    currency: '$',
  },
  'ru-ua': {
    title: 'Русский',
    currency: '₴',
  },
  ru: {
    title: 'Русский',
    currency: '₽',
  },
  de: {
    title: 'Deutsch',
    currency: '€',
  },
  es: {
    title: 'Español',
    currency: '€',
  },
  'en-ie': {
    title: 'English',
    currency: '€',
  },
  'ru-kz': {
    title: 'Русский',
    currency: '₸',
  },
  kz: {
    title: 'Қазақ',
    currency: '₸',
  },
  pl: {
    title: 'Polski',
    currency: 'zł',
  },
  tr: {
    title: 'Türkçe',
    currency: '₺',
  },
  'uk-ua': {
    title: 'Українська',
    currency: '₴',
  },
  'en-gb': {
    title: 'English',
    currency: '£',
  },
  'en-us': {
    title: 'English',
    currency: '$',
  },
  'ru-by': {
    title: 'Русский',
    currency: 'Br',
  },
  'fr-ch': {
    title: 'Français',
    currency: 'CHF',
  },
  'en-ch': {
    title: 'English',
    currency: 'CHF',
  },
  'de-ch': {
    title: 'Deutsch',
    currency: 'CHF',
  },
  fr: {
    title: 'Français',
    currency: '€',
  },
};
